// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/7eleven_logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html * {
  font-family: open sans, salesforce sans, sans-serif;
}

audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}

h1 {
  font-size: 20px;
}

.position-left {
  float: left;
}

.position-right {
  float: right;
}

.position-center {
  text-align: center;
}

.full-width {
  width: 100%;
}

.margin-center {
  margin: 0 auto;
}

.text-bold {
  font-weight: 700;
}

textarea {
  resize: vertical;
}

.margin-top-1 {
  margin-top: 1rem;
}

.margin-top-2 {
  margin-top: 2rem;
}

.margin-top-3 {
  margin-top: 3em !important;
}

.margin-top-7 {
  margin-top: 7em;
}

.margin-top-bottom-1 {
  margin-top: 1em;
  margin-bottom: 1em;
}

.margin-bottom-1 {
  margin-bottom: 1em;
}

.margin-bottom-2 {
  margin-bottom: 2em;
}

.margin-left-1 {
  margin-left: 1em;
}

.margin-left-2 {
  margin-left: 2em;
}

.margin-left-3 {
  margin-left: 3em;
}

.margin-right-2 {
  margin-right: 2em;
}

.padding-all-1 {
  padding: 1em;
}

.padding-all-2 {
  padding: 2em;
}

.form-width {
  width: 93%;
}

a {
  color: #1071c6;
  text-decoration: none;
}

a:hover {
  color: #1071c6;
  text-decoration: underline;
}

hr {
  margin: 3.2rem 0;
  border-top: 1px solid #dddbda;
}

.clear-both {
  clear: both;
}

.font-size-12 {
  font-size: 12rem;
}

.font-size-16 {
  font-size: 16px;
}

.font-size-18 {
  font-size: 18px;
}

.font-size-20 {
  font-size: 20px;
}

.overflow-hidden {
  overflow: hidden;
}

.margin-bottom-5 {
  margin-bottom: 5px;
}

#app {
  background: #f7f7f7;
}

.app-header {
  height: 100px;
  background: rgb(16, 127, 98, 0.25);
  line-height: 100px;
}

.app-header .header-logo {
  max-height: 58%;
  max-width: 60%;
}

.component-section {
  font-size: 18px;
  line-height: 22px;
  font: 14px/17px HelveticaNeueLTStd-Lt, Helvetica, Arial, sans-serif;
  margin: 0 0 30px;
}

/* 7-11 css */
.ccpa-form .ccpa-input input[type="email"],
.ccpa-form .ccpa-input input[type="number"],
.ccpa-form .ccpa-input input[type="password"],
.ccpa-form .ccpa-input input[type="tel"],
.ccpa-form .ccpa-input input[type="text"] {
  display: block;
  width: 100%;
  height: 21px;
  margin: 0;
  padding: 0;
  background: none;
  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;
  color: #000;
  border: 1px solid transparent;
  -webkit-appearance: none;
}

.ccpa-form .ccpa-input input::-webkit-outer-spin-button,
.ccpa-form .ccpa-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.main-content {
  transition-property: padding-top;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  background: #f7f7f7;
}

.ccpa-form legend {
  color: #757575;
  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;
}

.ccpa-wrapper {
  margin: 0 auto;
  padding: 15px 25px 15px 25px;
}

.heading {
  text-align: center;
  margin-bottom: 15px;
}

.ccpa-form {
  padding: 50px;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);
  border-radius: 8px;
  margin: 20px 0 0;
  text-align: left;
}

.ccpa-form label {
  color: #757575;
  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;
}

@media screen and (min-width: 768px) {
  .ccpa-form .ccpa-form-row .ccpa-form-col {
    float: left;
    padding: 0 20px;
  }

  .ccpa-form .ccpa-form-row .ccpa-form-col-small {
    width: 2%;
  }

  .ccpa-form .ccpa-form-row .ccpa-form-col-half {
    width: 45%;
  }

  .ccpa-form .ccpa-form-row .ccpa-form-col-whole {
    width: 100%;
  }
}

.ccpa-form .visiblity-hidden {
  visibility: hidden;
}

.ccpa-form .ccpa-label {
  position: relative;
  min-height: 20px;
  margin-bottom: 3px;
}

.ccpa-form .ccpa-input {
  position: relative;
  min-height: 25px;
  max-width: 650px;

  padding-bottom: 7px;
  border-bottom: 1px solid #565656;
}

.ccpa-form .ccpa-message {
  position: relative;
  min-height: 18px;
  margin: 7px 0 0;
  clear: left;
}

.ccpa-form .ccpa-error {
  color: #e41919;
  font: 12px/16px Heebo-Regular, Helvetica, Arial, sans-serif;
  margin: 0;
}

.ccpa-form .ccpa-textarea textarea {
  width: 100%;
  height: 70px;
}

.ccpa-form .ccpa-form-required-fields {
  margin: 0 0 30px 20px;
  text-align: left;
  font: 14px/21px Heebo-Regular, Helvetica, Arial, sans-serif;
  color: #757575;
}

.ccpa-form .ccpa-form-employee-required-fields {
  margin: 0 0 0 0;
  text-align: left;
  font: 14px/21px Heebo-Regular, Helvetica, Arial, sans-serif;
  color: #757575;
}

.ccpa-form .ccpa-radio-input {
  float: left;
  margin: 0 0 0 15px;
}

.ccpa-form .ccpa-radio-input label {
  float: left;
  margin: 0px 0px 0px 5px;
}

.ccpa-form .ccpa-radio-input input {
  float: left;
}

.ccpa-form .ccpa-select-option {
  float: left;
  margin: 0 0 0 15px;
}

.ccpa-form .ccpa-select-option label {
  float: left;
  margin: 0px 0px 0px 5px;
}

.ccpa-form .ccpa-select-group select {
  background-color: #f0f0f2;
  color: #676d79;
  border-radius: 5px;
  padding: 2px 20px 2px 10px;
}

.ccpa-form .ccpa-select-group select:focus {
  outline: 1px solid #1071c6;
}

.ccpa-form .ccpa-select-group input[type="checkbox"]:focus {
  outline: 1px solid #1071c6;
}

.ccpa-radio-input-group .ccpa-radio-input input[type="radio"]:focus {
  outline: 1px solid #1071c6;
}

.footer {
  background: #fff;
  -webkit-box-shadow: 0 -2px 2px 0 hsl(0deg 0% 73% / 50%);
  /* box-shadow: 0 -2px 2px 0 hsl(0deg 0% 73% / 50%); */
  text-align: left;
  z-index: 1;
  color: #4a4a4a;
  height: 170px;
}

.footer-inner {
  width: 40%;
  margin: 0 auto;
  padding: 40px;
  font-size: 11px;
  text-align: center;
}

.email-confirmation {
  max-width: 300px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  color: #696969;
}

.email-confirmation * {
  margin-top: 10px;
}

.email-confirmation p {
  font-size: 12px;
  margin-top: 30px;
}

/* 7-11 css end */

.submit-form label[required]:before {
  content: "*";
  color: #da5f5c;
  position: relative;
  vertical-align: super;
  font-size: 13px;
  font-family: FontAwesome;
}

.label-button,
.label-button-selected {
  width: 6.9rem;
  margin: 0.47rem;
  background-color: #f8f8f8;
  border-radius: 0.2rem;
  border: 1px solid #949494;
  padding: 0.4rem 1rem;
  font-weight: 400;
  color: #696969;
  cursor: pointer;
  display: inline-block;
  text-align: center;
}

.label-button-selected {
  color: #fff;
  background-color: #1f96db;
  border: 1px solid #000;
}

.label-button:hover {
  color: #1f96db;
  border: 1px solid #1f96db;
}

.one-input {
  border-radius: 3px;
  color: #696969;
  height: 2rem;
  padding: 0 1rem;
  border: 1px solid #949494;
}

.one-text-area {
  height: 3rem;
  padding: 1rem;
}

#submit-button,
#privacy-button,
#Download-btn,
#reply-button,
#logout-button {
  font: 700 16px/40px Roboto, Helvetica, Arial, sans-serif;
  color: #fff;
  background-color: #2ca371;
  border: 2px solid #2ca371;
  min-height: 36px;
  min-width: 120px;
  border-radius: 25px;
  text-align: center;
  padding: 0 30px;
  cursor: pointer;
}

#submit-button:disabled,
#privacy-button:disabled,
#reply-button:disabled {
  cursor: default;
  opacity: 0.4;
}

#privacy-button {
  min-width: 10rem;
}

.min-height-85-percent {
  min-height: 85%;
}

.shadow8 {
  box-shadow: 0 2px 4px 0 transparent, 0 7px 14px 0 rgba(50, 50, 93, 0.1);
}

.max-width-20 {
  max-width: 20em;
}

.max-width-30 {
  max-width: 30rem;
}

.max-width-24 {
  max-width: 24rem;
}

.border-radius-5 {
  border-radius: 5px;
}

.border-platinum {
  border: 1px solid #d7d7d7;
}

.max-height-34 {
  height: 34em;
}

.section-font-color {
  color: #696969;
}

.font-size-20 {
  font-size: 20px;
}

.font-size-14 {
  font-size: 14px;
}

#requestDetails_lengthCount {
  color: #696969;
  margin-bottom: 10px;
}

.border-has-error {
  border: 1px solid #fc4f45 !important;
}

.code-verify-error {
  border: 1px solid #de1010 !important;
}

.code-error-hide {
  display: none;
}

.code-error-visible {
  display: block;
  color: #de1010;
  font-size: 12px;
  margin-top: 0.5rem;
}

#access-code input {
  border-radius: 3px;
  color: #696969;
  height: 1.9rem;
  padding: 0 1rem;
  border: 1px solid #949494;
  margin-top: 0.5rem;
}

.request-detail-panel {
  margin: 2em;
  overflow: hidden;
}

.form-element {
  padding-bottom: 2em;
}

.form-element label {
  width: 45%;
  float: left;
  font-size: 13px;
  font-weight: bold;
}

.form-element span {
  width: 55%;
  float: left;
  font-size: 14px;
}

.section-col1,
.section-col2 {
  width: 45%;
  float: left;
  border: 2px solid #ddd;
  padding: 2%;
}

.section-col2 {
  float: right;
}

.display-comments-section {
  padding: 0em 3em;
  border: 2px solid #ddd;
  margin: 2em;
}

.display-comments {
  border: 1px solid #ddd;
  padding: 1em;
  margin: 1em 4em;
}

.display-content {
  margin-left: 50px;
  margin-top: 20px;
}

#Download-btn {
  margin-top: 15px;
}

@media only screen and (max-width: 900px) {
  .section-col1 {
    width: 95%;
  }

  .section-col2 {
    clear: both;
    margin-top: 20px;
    float: left;
    width: 95%;
  }
}

@media only screen and (max-width: 699px) {
  .ccpa-wrapper {
    padding: 20px;
  }

  .request-detail-panel {
    margin: 10px;
  }

  .display-comments-section {
    margin: 10px;
    padding: 0 10px;
  }

  .display-comments,
  .reply-button-section {
    margin: 20px;
  }

  .display-content {
    margin-left: 10px;
  }

  .RichTextEditor__root___2QXK- {
    height: 15em !important;
  }
}

@media only screen and (max-width: 455px) {
  .RichTextEditor__root___2QXK- {
    height: 20em !important;
  }

  .reply-button-section {
    margin: 1em !important;
  }
}

#reply-button {
  text-transform: none;
}

.reply-button-section {
  margin: 1em 4em;
}

.RichTextEditor__root___2QXK- {
  height: 10em;
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn {
  display: inline-block;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0px 30px;
  min-height: 46px;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 25px;
}

.timeout {
  border: 1px solid #de1010;
  padding: 8px;
  color: #fff;
  background: #de1010;
  font-size: 14px;
  margin-top: 5em;
}

.xss-error {
  color: #e41919;
  font-size: 15px !important;
}

.email-image {
  height: 8em;
}

.request-text {
  display: block;
}

.del-act-form {
  padding: 15px 20px 15px 20px;
  background: #fff;
  border-top: 5px solid #f1f1f1;
  font: 14px/17px HelveticaNeueLTStd-Lt, Helvetica, Arial, sans-serif;
}

.form-header {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-top-5 {
  margin-top: 5px;
}

.del-act-form .ccpa-input {
  position: relative;
  min-height: 25px;
  max-width: 650px;
  padding-bottom: 7px;
  border-bottom: 1px solid #565656;
}

.del-act-form .visiblity-hidden {
  visibility: hidden;
}

.del-act-form label {
  color: #757575;
  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;
}

.del-act-form .ccpa-input input[type="text"],
.del-act-form .ccpa-input input[type="tel"] {
  display: block;
  width: 100%;
  height: 21px;
  margin: 0;
  padding: 0;
  background: none;
  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;
  color: #000;
  border: 1px solid transparent;
  -webkit-appearance: none;
}

.del-act-form .ccpa-textarea textarea {
  width: 100%;
  height: 70px;
}

.del-act-form .ccpa-error {
  color: #e41919;
  font: 12px/16px Heebo-Regular, Helvetica, Arial, sans-serif;
  margin: 0;
}

.modal-wrapper {
  width: 30%;
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgb(133, 133, 133);
  margin: 0 auto;
  padding: 20px 10px;
  position: absolute;
  z-index: 9;
  bottom: -118%;
  left: 30%;
  text-align: center;
}

.modal-header {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.model-body {
  margin: 15px 0;
  font-size: 12px;
  color: #757575;
  line-height: 15px;
}

.del-act-modal.modal-wrapper {
  bottom: -86%;
}

.del-act-modal .modal-body {
  font-size: 13px;
  margin: 1em;
}

.seven-eleven-bg {
  display: inline-block;
  width: 50px;
  height: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  border: 1px solid #ececec;
  border-radius: 7px;
}

.seven-now-bg {
  display: inline-block;
  width: 50px;
  height: 50px;
  /* background-image: url('../Images/7now_logo.png'); */
  background-size: cover;
  border: 1px solid #ececec;
  border-radius: 7px;
}

.logo-text {
  float: left;
  margin: 10px 0 0 10px;
}

.margin-top-8 {
  margin-top: 8em;
}

.height-20 {
  height: 20px;
}

.height-60 {
  height: 60px;
}

.phone-watermark {
  position: absolute;
  top: 34%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
  font-size: 14px;
}

.ccpa-input .phoneNum {
  padding-left: 20px !important;
}

.org-consumer-pa {
  font-style: italic !important;
  margin-bottom: 1em;
  float: left;
  font-weight: bold !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mEAAmE;EACnE,gBAAgB;AAClB;;AAEA,aAAa;AACb;;;;;EAKE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2DAA2D;EAC3D,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAEE,gCAAgC;EAEhC,yBAAyB;EAEzB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAEhB,wCAAwC;EAExC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uDAAuD;EACvD,qDAAqD;EACrD,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;EAKE,wDAAwD;EACxD,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,mEAAmE;AACrE;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2DAA2D;AAC7D;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2DAA2D;EAC3D,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yDAAmD;EACnD,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sDAAsD;EACtD,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B","sourcesContent":["html * {\n  font-family: open sans, salesforce sans, sans-serif;\n}\n\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n  vertical-align: middle;\n}\n\nh1 {\n  font-size: 20px;\n}\n\n.position-left {\n  float: left;\n}\n\n.position-right {\n  float: right;\n}\n\n.position-center {\n  text-align: center;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.margin-center {\n  margin: 0 auto;\n}\n\n.text-bold {\n  font-weight: 700;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.margin-top-1 {\n  margin-top: 1rem;\n}\n\n.margin-top-2 {\n  margin-top: 2rem;\n}\n\n.margin-top-3 {\n  margin-top: 3em !important;\n}\n\n.margin-top-7 {\n  margin-top: 7em;\n}\n\n.margin-top-bottom-1 {\n  margin-top: 1em;\n  margin-bottom: 1em;\n}\n\n.margin-bottom-1 {\n  margin-bottom: 1em;\n}\n\n.margin-bottom-2 {\n  margin-bottom: 2em;\n}\n\n.margin-left-1 {\n  margin-left: 1em;\n}\n\n.margin-left-2 {\n  margin-left: 2em;\n}\n\n.margin-left-3 {\n  margin-left: 3em;\n}\n\n.margin-right-2 {\n  margin-right: 2em;\n}\n\n.padding-all-1 {\n  padding: 1em;\n}\n\n.padding-all-2 {\n  padding: 2em;\n}\n\n.form-width {\n  width: 93%;\n}\n\na {\n  color: #1071c6;\n  text-decoration: none;\n}\n\na:hover {\n  color: #1071c6;\n  text-decoration: underline;\n}\n\nhr {\n  margin: 3.2rem 0;\n  border-top: 1px solid #dddbda;\n}\n\n.clear-both {\n  clear: both;\n}\n\n.font-size-12 {\n  font-size: 12rem;\n}\n\n.font-size-16 {\n  font-size: 16px;\n}\n\n.font-size-18 {\n  font-size: 18px;\n}\n\n.font-size-20 {\n  font-size: 20px;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.margin-bottom-5 {\n  margin-bottom: 5px;\n}\n\n#app {\n  background: #f7f7f7;\n}\n\n.app-header {\n  height: 100px;\n  background: rgb(16, 127, 98, 0.25);\n  line-height: 100px;\n}\n\n.app-header .header-logo {\n  max-height: 58%;\n  max-width: 60%;\n}\n\n.component-section {\n  font-size: 18px;\n  line-height: 22px;\n  font: 14px/17px HelveticaNeueLTStd-Lt, Helvetica, Arial, sans-serif;\n  margin: 0 0 30px;\n}\n\n/* 7-11 css */\n.ccpa-form .ccpa-input input[type=\"email\"],\n.ccpa-form .ccpa-input input[type=\"number\"],\n.ccpa-form .ccpa-input input[type=\"password\"],\n.ccpa-form .ccpa-input input[type=\"tel\"],\n.ccpa-form .ccpa-input input[type=\"text\"] {\n  display: block;\n  width: 100%;\n  height: 21px;\n  margin: 0;\n  padding: 0;\n  background: none;\n  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;\n  color: #000;\n  border: 1px solid transparent;\n  -webkit-appearance: none;\n}\n\n.ccpa-form .ccpa-input input::-webkit-outer-spin-button,\n.ccpa-form .ccpa-input input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.main-content {\n  -webkit-transition-property: padding-top;\n  transition-property: padding-top;\n  -webkit-transition-duration: 0.5s;\n  transition-duration: 0.5s;\n  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  background: #f7f7f7;\n}\n\n.ccpa-form legend {\n  color: #757575;\n  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;\n}\n\n.ccpa-wrapper {\n  margin: 0 auto;\n  padding: 15px 25px 15px 25px;\n}\n\n.heading {\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.ccpa-form {\n  padding: 50px;\n  background: #fff;\n  -webkit-box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);\n  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n  margin: 20px 0 0;\n  text-align: left;\n}\n\n.ccpa-form label {\n  color: #757575;\n  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;\n}\n\n@media screen and (min-width: 768px) {\n  .ccpa-form .ccpa-form-row .ccpa-form-col {\n    float: left;\n    padding: 0 20px;\n  }\n\n  .ccpa-form .ccpa-form-row .ccpa-form-col-small {\n    width: 2%;\n  }\n\n  .ccpa-form .ccpa-form-row .ccpa-form-col-half {\n    width: 45%;\n  }\n\n  .ccpa-form .ccpa-form-row .ccpa-form-col-whole {\n    width: 100%;\n  }\n}\n\n.ccpa-form .visiblity-hidden {\n  visibility: hidden;\n}\n\n.ccpa-form .ccpa-label {\n  position: relative;\n  min-height: 20px;\n  margin-bottom: 3px;\n}\n\n.ccpa-form .ccpa-input {\n  position: relative;\n  min-height: 25px;\n  max-width: 650px;\n\n  padding-bottom: 7px;\n  border-bottom: 1px solid #565656;\n}\n\n.ccpa-form .ccpa-message {\n  position: relative;\n  min-height: 18px;\n  margin: 7px 0 0;\n  clear: left;\n}\n\n.ccpa-form .ccpa-error {\n  color: #e41919;\n  font: 12px/16px Heebo-Regular, Helvetica, Arial, sans-serif;\n  margin: 0;\n}\n\n.ccpa-form .ccpa-textarea textarea {\n  width: 100%;\n  height: 70px;\n}\n\n.ccpa-form .ccpa-form-required-fields {\n  margin: 0 0 30px 20px;\n  text-align: left;\n  font: 14px/21px Heebo-Regular, Helvetica, Arial, sans-serif;\n  color: #757575;\n}\n\n.ccpa-form .ccpa-form-employee-required-fields {\n  margin: 0 0 0 0;\n  text-align: left;\n  font: 14px/21px Heebo-Regular, Helvetica, Arial, sans-serif;\n  color: #757575;\n}\n\n.ccpa-form .ccpa-radio-input {\n  float: left;\n  margin: 0 0 0 15px;\n}\n\n.ccpa-form .ccpa-radio-input label {\n  float: left;\n  margin: 0px 0px 0px 5px;\n}\n\n.ccpa-form .ccpa-radio-input input {\n  float: left;\n}\n\n.ccpa-form .ccpa-select-option {\n  float: left;\n  margin: 0 0 0 15px;\n}\n\n.ccpa-form .ccpa-select-option label {\n  float: left;\n  margin: 0px 0px 0px 5px;\n}\n\n.ccpa-form .ccpa-select-group select {\n  background-color: #f0f0f2;\n  color: #676d79;\n  border-radius: 5px;\n  padding: 2px 20px 2px 10px;\n}\n\n.ccpa-form .ccpa-select-group select:focus {\n  outline: 1px solid #1071c6;\n}\n\n.ccpa-form .ccpa-select-group input[type=\"checkbox\"]:focus {\n  outline: 1px solid #1071c6;\n}\n\n.ccpa-radio-input-group .ccpa-radio-input input[type=\"radio\"]:focus {\n  outline: 1px solid #1071c6;\n}\n\n.footer {\n  background: #fff;\n  -webkit-box-shadow: 0 -2px 2px 0 hsl(0deg 0% 73% / 50%);\n  /* box-shadow: 0 -2px 2px 0 hsl(0deg 0% 73% / 50%); */\n  text-align: left;\n  z-index: 1;\n  color: #4a4a4a;\n  height: 170px;\n}\n\n.footer-inner {\n  width: 40%;\n  margin: 0 auto;\n  padding: 40px;\n  font-size: 11px;\n  text-align: center;\n}\n\n.email-confirmation {\n  max-width: 300px;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: center;\n  color: #696969;\n}\n\n.email-confirmation * {\n  margin-top: 10px;\n}\n\n.email-confirmation p {\n  font-size: 12px;\n  margin-top: 30px;\n}\n\n/* 7-11 css end */\n\n.submit-form label[required]:before {\n  content: \"*\";\n  color: #da5f5c;\n  position: relative;\n  vertical-align: super;\n  font-size: 13px;\n  font-family: FontAwesome;\n}\n\n.label-button,\n.label-button-selected {\n  width: 6.9rem;\n  margin: 0.47rem;\n  background-color: #f8f8f8;\n  border-radius: 0.2rem;\n  border: 1px solid #949494;\n  padding: 0.4rem 1rem;\n  font-weight: 400;\n  color: #696969;\n  cursor: pointer;\n  display: inline-block;\n  text-align: center;\n}\n\n.label-button-selected {\n  color: #fff;\n  background-color: #1f96db;\n  border: 1px solid #000;\n}\n\n.label-button:hover {\n  color: #1f96db;\n  border: 1px solid #1f96db;\n}\n\n.one-input {\n  border-radius: 3px;\n  color: #696969;\n  height: 2rem;\n  padding: 0 1rem;\n  border: 1px solid #949494;\n}\n\n.one-text-area {\n  height: 3rem;\n  padding: 1rem;\n}\n\n#submit-button,\n#privacy-button,\n#Download-btn,\n#reply-button,\n#logout-button {\n  font: 700 16px/40px Roboto, Helvetica, Arial, sans-serif;\n  color: #fff;\n  background-color: #2ca371;\n  border: 2px solid #2ca371;\n  min-height: 36px;\n  min-width: 120px;\n  border-radius: 25px;\n  text-align: center;\n  padding: 0 30px;\n  cursor: pointer;\n}\n\n#submit-button:disabled,\n#privacy-button:disabled,\n#reply-button:disabled {\n  cursor: default;\n  opacity: 0.4;\n}\n\n#privacy-button {\n  min-width: 10rem;\n}\n\n.min-height-85-percent {\n  min-height: 85%;\n}\n\n.shadow8 {\n  box-shadow: 0 2px 4px 0 transparent, 0 7px 14px 0 rgba(50, 50, 93, 0.1);\n}\n\n.max-width-20 {\n  max-width: 20em;\n}\n\n.max-width-30 {\n  max-width: 30rem;\n}\n\n.max-width-24 {\n  max-width: 24rem;\n}\n\n.border-radius-5 {\n  border-radius: 5px;\n}\n\n.border-platinum {\n  border: 1px solid #d7d7d7;\n}\n\n.max-height-34 {\n  height: 34em;\n}\n\n.section-font-color {\n  color: #696969;\n}\n\n.font-size-20 {\n  font-size: 20px;\n}\n\n.font-size-14 {\n  font-size: 14px;\n}\n\n#requestDetails_lengthCount {\n  color: #696969;\n  margin-bottom: 10px;\n}\n\n.border-has-error {\n  border: 1px solid #fc4f45 !important;\n}\n\n.code-verify-error {\n  border: 1px solid #de1010 !important;\n}\n\n.code-error-hide {\n  display: none;\n}\n\n.code-error-visible {\n  display: block;\n  color: #de1010;\n  font-size: 12px;\n  margin-top: 0.5rem;\n}\n\n#access-code input {\n  border-radius: 3px;\n  color: #696969;\n  height: 1.9rem;\n  padding: 0 1rem;\n  border: 1px solid #949494;\n  margin-top: 0.5rem;\n}\n\n.request-detail-panel {\n  margin: 2em;\n  overflow: hidden;\n}\n\n.form-element {\n  padding-bottom: 2em;\n}\n\n.form-element label {\n  width: 45%;\n  float: left;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.form-element span {\n  width: 55%;\n  float: left;\n  font-size: 14px;\n}\n\n.section-col1,\n.section-col2 {\n  width: 45%;\n  float: left;\n  border: 2px solid #ddd;\n  padding: 2%;\n}\n\n.section-col2 {\n  float: right;\n}\n\n.display-comments-section {\n  padding: 0em 3em;\n  border: 2px solid #ddd;\n  margin: 2em;\n}\n\n.display-comments {\n  border: 1px solid #ddd;\n  padding: 1em;\n  margin: 1em 4em;\n}\n\n.display-content {\n  margin-left: 50px;\n  margin-top: 20px;\n}\n\n#Download-btn {\n  margin-top: 15px;\n}\n\n@media only screen and (max-width: 900px) {\n  .section-col1 {\n    width: 95%;\n  }\n\n  .section-col2 {\n    clear: both;\n    margin-top: 20px;\n    float: left;\n    width: 95%;\n  }\n}\n\n@media only screen and (max-width: 699px) {\n  .ccpa-wrapper {\n    padding: 20px;\n  }\n\n  .request-detail-panel {\n    margin: 10px;\n  }\n\n  .display-comments-section {\n    margin: 10px;\n    padding: 0 10px;\n  }\n\n  .display-comments,\n  .reply-button-section {\n    margin: 20px;\n  }\n\n  .display-content {\n    margin-left: 10px;\n  }\n\n  .RichTextEditor__root___2QXK- {\n    height: 15em !important;\n  }\n}\n\n@media only screen and (max-width: 455px) {\n  .RichTextEditor__root___2QXK- {\n    height: 20em !important;\n  }\n\n  .reply-button-section {\n    margin: 1em !important;\n  }\n}\n\n#reply-button {\n  text-transform: none;\n}\n\n.reply-button-section {\n  margin: 1em 4em;\n}\n\n.RichTextEditor__root___2QXK- {\n  height: 10em;\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 700;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0px 30px;\n  min-height: 46px;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 25px;\n}\n\n.timeout {\n  border: 1px solid #de1010;\n  padding: 8px;\n  color: #fff;\n  background: #de1010;\n  font-size: 14px;\n  margin-top: 5em;\n}\n\n.xss-error {\n  color: #e41919;\n  font-size: 15px !important;\n}\n\n.email-image {\n  height: 8em;\n}\n\n.request-text {\n  display: block;\n}\n\n.del-act-form {\n  padding: 15px 20px 15px 20px;\n  background: #fff;\n  border-top: 5px solid #f1f1f1;\n  font: 14px/17px HelveticaNeueLTStd-Lt, Helvetica, Arial, sans-serif;\n}\n\n.form-header {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.margin-top-10 {\n  margin-top: 10px;\n}\n\n.margin-top-5 {\n  margin-top: 5px;\n}\n\n.del-act-form .ccpa-input {\n  position: relative;\n  min-height: 25px;\n  max-width: 650px;\n  padding-bottom: 7px;\n  border-bottom: 1px solid #565656;\n}\n\n.del-act-form .visiblity-hidden {\n  visibility: hidden;\n}\n\n.del-act-form label {\n  color: #757575;\n  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;\n}\n\n.del-act-form .ccpa-input input[type=\"text\"],\n.del-act-form .ccpa-input input[type=\"tel\"] {\n  display: block;\n  width: 100%;\n  height: 21px;\n  margin: 0;\n  padding: 0;\n  background: none;\n  font: 14px/18px Heebo-Regular, Helvetica, Arial, sans-serif;\n  color: #000;\n  border: 1px solid transparent;\n  -webkit-appearance: none;\n}\n\n.del-act-form .ccpa-textarea textarea {\n  width: 100%;\n  height: 70px;\n}\n\n.del-act-form .ccpa-error {\n  color: #e41919;\n  font: 12px/16px Heebo-Regular, Helvetica, Arial, sans-serif;\n  margin: 0;\n}\n\n.modal-wrapper {\n  width: 30%;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid rgb(133, 133, 133);\n  margin: 0 auto;\n  padding: 20px 10px;\n  position: absolute;\n  z-index: 9;\n  bottom: -118%;\n  left: 30%;\n  text-align: center;\n}\n\n.modal-header {\n  font-size: 14px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.model-body {\n  margin: 15px 0;\n  font-size: 12px;\n  color: #757575;\n  line-height: 15px;\n}\n\n.del-act-modal.modal-wrapper {\n  bottom: -86%;\n}\n\n.del-act-modal .modal-body {\n  font-size: 13px;\n  margin: 1em;\n}\n\n.seven-eleven-bg {\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  background-image: url(\"../Images/7eleven_logo.png\");\n  background-size: cover;\n  border: 1px solid #ececec;\n  border-radius: 7px;\n}\n\n.seven-now-bg {\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  /* background-image: url('../Images/7now_logo.png'); */\n  background-size: cover;\n  border: 1px solid #ececec;\n  border-radius: 7px;\n}\n\n.logo-text {\n  float: left;\n  margin: 10px 0 0 10px;\n}\n\n.margin-top-8 {\n  margin-top: 8em;\n}\n\n.height-20 {\n  height: 20px;\n}\n\n.height-60 {\n  height: 60px;\n}\n\n.phone-watermark {\n  position: absolute;\n  top: 34%;\n  transform: translateY(-50%);\n  color: #999;\n  pointer-events: none;\n  font-size: 14px;\n}\n\n.ccpa-input .phoneNum {\n  padding-left: 20px !important;\n}\n\n.org-consumer-pa {\n  font-style: italic !important;\n  margin-bottom: 1em;\n  float: left;\n  font-weight: bold !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
